<template>
    <div class="category_title_menu">
      <van-tabs v-model:active="active" scrollspy sticky color="#666">
        <van-tab v-for="(item, index) in Categorys" :key="index">
          <template #title> {{ item.Name }} </template>
          <div class="category_content_itemtitle">
            {{ item.Name }}
          </div>
          <div
            class="product_content"
            v-for="(product, indexs) in item.Products"
            :key="indexs"
          >
            <div class="product_item">
              <TakeOutProductBroadwise :ProductItem="product" />
            </div>
          </div>
        </van-tab>
      </van-tabs>
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
    <TakeOutTabbar />

  </template>
<script>
import axios from "../../commons/AxiosMethod.js"
import TakeOutProductBroadwise from "../../components/TakeOuts/TakeOutProductBroadwise.vue"
import TakeOutTabbar from "../../components/tabbars/TakeOutTabbar.vue"

import { Collapse, CollapseItem, Tab, Tabs } from "vant"
export default {
  data () {
    return {
      index: 0,
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,

      active: "",
      Categorys: [], // �����б�
      CategoryOpt: {} // ��ǰ����

    }
  },
  name: "App",
  mounted () {
    localStorage.setItem("Cache-TableId", this.$route.query.tableId)
    this.TableId = localStorage.getItem("Cache-TableId")
    this.GetCategorys()
  },
  components: {
    TakeOutProductBroadwise,
    TakeOutTabbar
  },
  methods: {

    // ��ȡ����
    GetCategorys () {
      var param = {
        Where: {
          Size: 100
        }
      }
      axios.apiMethod(
        "/Store/StoreOrder/GetCategoryProductSimple",
        "post",
        param,
        (result) => {
          for (var i = 0; i < result.Data.length; i++) {
            this.Categorys.push(result.Data[i])
          }
        }
      )
    }
  }
}
</script>
  <style lang="scss" scoped>
  .category_content_itemtitle {
    font-size: 12pt;
    font-weight: 700;
    font-size: 14pt;
    padding: 10px 20px;
  }
  .search_content {
    height: 70px;
    display: flex;
    .search {
      width: 100%;
    }
  }
  .category_title_menu {
    width: 100%;
    background-color: #fff;
    top: 0px;
    z-index: 9090000;
    border-bottom: 1px solid #eee;
  }

  .product_content {
    width: calc(100% - 20px);
    margin: 0 auto;
    padding: 5px !important;
    border-radius: 5px;
    .product_item {
      width: calc(100% - 20px);
      margin: 0 auto;
      margin-top: 10px;
    }
  }
  </style>
